module.exports = __webpack_public_path__ + "img/shouru.51785662.png";